import { createContext, useContext } from 'react'
import type { BasemapKind } from '@/lib/map'

export interface BasemapContextValue {
  kind: BasemapKind
  setKind: (next: BasemapKind) => void
  toggle: () => void
}

export const BasemapContext = createContext<BasemapContextValue | null>(null)

export function useBasemap(): BasemapContextValue {
  const ctx = useContext(BasemapContext)
  if (!ctx) {
    throw new Error('useBasemap must be used inside <BasemapProvider>')
  }
  return ctx
}

export const BASEMAP_STORAGE_KEY = 'gb_basemap'
